// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/navbar/navbar";
import Home from "./components/home/home";
import AboutUs from "./components/about/about";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import GalleryAndCertificate from "./components/product/product";
import ContactForm from "./components/contact/ContactForm";
import OurBusiness from "./components/business/business";

// ✅ Import WhatsApp icon (Font Awesome or any custom SVG)
import { FaWhatsapp } from "react-icons/fa";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disableMutationObserver: true,
    });
  }, []);

  return (
    <Router>
      <div className="app-background">
        <NavigationBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route
            path="/product"
            element={<GalleryAndCertificate />}
          />
          <Route path="/business" element={<OurBusiness />} />
          <Route path="/contact" element={<ContactForm />} />
        </Routes>

        {/* ✅ Floating WhatsApp Icon */}
        <a
          href="https://wa.me/916238502812" // replace with your WhatsApp number
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp className="whatsapp-icon" />
        </a>
      </div>
    </Router>
  );
}

export default App;
